import { getNormalizedUserEmail } from '../../common/userIdentity';

type QmCommentLike = {
  createdBy?: string | null;
};

type QmRecordLike = {
  updatedBy?: string | null;
  comments?: QmCommentLike[] | null;
};

type QmLiveUpdateTypeLike = 'CREATED' | 'UPDATED' | 'COMMENTED';

export function isSelfTriggeredLiveEvent(params: {
  type: QmLiveUpdateTypeLike;
  record: QmRecordLike;
  normalizedUserEmail: string | null;
}): boolean {
  const { type, record, normalizedUserEmail } = params;

  if (!normalizedUserEmail) return false;

  if (type === 'CREATED') {
    // Keep CREATED events live even for the same user so newly raised QMs appear immediately.
    return false;
  }

  if (type === 'UPDATED') {
    return getNormalizedUserEmail(record.updatedBy) === normalizedUserEmail;
  }

  if (type === 'COMMENTED') {
    const latestComment =
      record.comments && record.comments.length > 0 ? record.comments[record.comments.length - 1] : null;
    return getNormalizedUserEmail(latestComment?.createdBy) === normalizedUserEmail;
  }

  return false;
}
